<template>
  <v-layout column justify-start>
    <label :id="labelId" class="v-label v-label--active theme--light small-label">Time range</label>
    <v-range-slider
      style="margin-top:10px;"
      :messages="`${ampm[0]}-${ampm[1]}`"
      v-model="minutes"
      :min="0"
      :max="1439"
      :step="5"
      height=10
      :aria-labelledby="labelId"
      :aria-valuetext="`${ampm[0]} to ${ampm[1]}`"
      @change="$emit('change')"
    ></v-range-slider>
  </v-layout>
</template>

<script>
  /* eslint-disable */
  export default {
    data: () => ({
      startTimeMenu: false,
      endTimeMenu: false
    }),
    props: ['value'],
    computed: {
      labelId () {
        return `time-range-label-${this._uid}`
      },
      minutes: {
        get: function() {
          return this.value.map(function(time){
            let [hours, minutes] = time.split(':')
            return parseInt(hours) * 60 + parseInt(minutes)
          })
        },
        set: function(newMinutes) {
          let newTimes = newMinutes.map(function(minutes){
            let hours = Math.floor(minutes/60)
            let remMinutes = minutes - hours * 60

            let twoDigit = (num) => num < 10 ? `0${num}` : num

            return `${hours}:${twoDigit(remMinutes)}`
          })
          this.$emit('input', newTimes)
        }
      },
      ampm: {
        get: function() {
          return this.value.map(function(time){
            let [hours, minutes] = time.split(':')
            let suffix

            if(hours > 12){
              hours -= 12
              suffix = 'PM'
            } else if(hours == 12){
              suffix = 'PM'
            } else if(hours == 0){
              hours = 12
              suffix = 'AM'
            } else {
              suffix = 'AM'
            }

            return `${hours}:${minutes}${suffix}`
          })
        }
      }
    }
  }
</script>

<style>
  .small-label{
    transform: scale(0.75);
    transform-origin: left;
  }
</style>